
import Vue from 'vue';
import _ from 'lodash';
import QrcodeVue from 'qrcode.vue';
import { currency } from '@/helpers/currency';
import { qrCodeValue } from '@/helpers/qrCodeValue';

export default Vue.extend({
  components: { QrcodeVue },
  props: {
    input: { type: Object, default: () => {} },
    data: { type: Object, default: () => {} },
    getVariable: { type: Function, default: () => () => {} },
    callFunction: { type: Function, default: () => () => {} },
    onChange: { type: Function, default: () => {} },
    parent: { type: Object, default: () => {} }
  },
  computed: {
    subTotal: function() : any {
      const _item = this.getVariable(this.input.variable);
      return this.parent._resolveFormulaValue(this.input.config.subTotalFormula, { _item });
    },
    total: function(): any {
      const _item = this.getVariable(this.input.variable);
      return this.parent._resolveFormulaValue(this.input.config.totalFormula, { _item });
    },
    qrCodeValue: function(): string {
      const qrCode = this.getVariable(this.input.config.qrCodeVariable);
      if(qrCode) {
        return qrCode;
      }
      const _item = this.getVariable(this.input.variable);
      const docDetails = this.parent._resolveFormulaValue(this.input.config.docDetails, { _item });
      const createdDate = new Date(_.get(docDetails, 'createdAt', ''));
      const year  = createdDate.getFullYear();
      const month = createdDate.getMonth();
      if(year > 2024 || (year == 2024 && month > 8)) return ''; // qr code will not load after 30 Sep 2024 if not returned by API
      const companyDetails = this.parent._resolveFormulaValue(this.input.config.companyDetails, { _item });
      return qrCodeValue({ companyDetails, docDetails, total: this.total, vat: this.total-this.subTotal });
    },
    vatPercent: function(): number {
      return this.parent._resolveFormulaValue(this.input.config.vatVariable);
    }
  },
  methods: {
    currencyFormat: function(numValue: number) {
      return currency(numValue);
    }
  }
})
